@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackSearch {
  .title {
    font-size: 36px;
    margin-bottom: 40px;

    @include texts.font("bold");
  }

  .search {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 14px;

    .google {
      width: 130px;
      height: 43px;

      @include icons.ico("colored-google-text");
    }

    .input {
      display: flex;
      padding: 18px 20px 18px 46px;
      margin-left: 10px;
      border-radius: 48px;
      border: 1px solid rgba(255, 255, 255, 0.10);
      background: rgba(255, 255, 255, 0.05);
      position: relative;

      .icon {
        position: absolute;
        filter: var(--icon-white);
        width: 20px;
        height: 20px;
        left: 14px;
        opacity: 0.1;

        @include icons.ico("black-search");
      }
    }
  }

  .stats {
    margin-bottom: 50px;
  }

  @media screen and (max-width: 930px) {
    .title {
      font-size: 23px !important;
    }

    .search {
      .google {
        width: 72px;
        height: 23px;
      }

      .input {
        padding: 10px 10px 10px 30px;
        font-size: 12px;

        .icon {
          width: 14px;
          height: 14px;
          position: absolute;
          left: 10px;
        }
      }
    }
  }
}